const COMMENTS = [
  { id: 'c1', name: '吃瓜不嫌事大', text: '这个站太会追热点了！每天打开就能看到最新的事件汇总，终于不用在各大平台来回切换了，五一吃瓜网直接一站式解决。', time: '2 小时前', likes: 287 },
  { id: 'c2', name: '云上吃瓜人', text: '追了好几个热门事件的完整时间线，整理得特别清楚，比那些碎片化的热搜要有用多了。推荐给所有爱吃瓜的朋友！', time: '5 小时前', likes: 156 },
  { id: 'c3', name: '八卦研究员', text: '吃瓜事件汇总那个板块简直是宝藏，好多我没注意到的小众热门爆料都收录了，而且更新速度真的快，点赞！', time: '8 小时前', likes: 203 },
  { id: 'c4', name: '理性的猹', text: '内容质量挺高的，不是单纯搬运热搜，而是有整理有归纳。网络大事件的追踪也很及时，每天上班路上必刷。', time: '12 小时前', likes: 134 },
  { id: 'c5', name: '深夜吃瓜人', text: '深度追踪做得不错，尤其是热门事件的时间线梳理，让人一目了然。希望继续保持这种高质量的内容输出！', time: '1 天前', likes: 321 },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          吃瓜群众说
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          来看看大家都在讨论什么
        </p>
        <div className="space-y-5">
          {COMMENTS.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.text}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {c.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}